import PermissionContext, {
	type PermissionContextValue,
} from '@UI/Providers/PermissionProvider/PermissionContext';
import * as React from 'react';

function useUserPermissions(): PermissionContextValue {
	const context = React.useContext(PermissionContext);

	if (context === null) {
		throw new Error('useUserPermissions must be used within a PermissionProvider.');
	}

	return context;
}

export default useUserPermissions;
